export function otherArticlesSlider() {

	if ($(window).width() <= '968') {
		$('.js-other-articles_wrapper').slick({
			infinite: false,
			arrows: false,
			dots: true,
			slidesToShow: 2,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}
}